import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import LazyLoad from 'react-lazyload';
import InternalBanner from './InternalBanner';
import SkelotonEffect from './SkelotonEffect';
import { useAuth } from '../AuthContext';
import { FacebookShareButton, FacebookIcon, WhatsappIcon, WhatsappShareButton, TwitterShareButton, XIcon } from "react-share";

export default function ImageViewer() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const images = state?.images || [];
    const eventName = state?.name || 'Event';
    const eventVenue = state?.venue || 'Event Venue';
    const [isLoading, setIsLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const { isAuthenticated } = useAuth();

    const handleClick = (index) => {
        setCurrentIndex(index);
        setIsOpen(true);
    };

    // Simulate loading
    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsLoading(false);
        }, 1000); // simulate 1s loading
        return () => clearTimeout(timeout);
    }, []);

    if (isLoading) {
        return <SkelotonEffect />;
    }

    /*  const handleDownload = async (url, filename) => {
         try {
             const response = await fetch(url, { mode: 'cors' });
             const blob = await response.blob();
             const blobUrl = window.URL.createObjectURL(blob);
 
             const link = document.createElement('a');
             link.href = blobUrl;
             link.download = filename || 'downloaded_image.jpg';
             document.body.appendChild(link);
             link.click();
             document.body.removeChild(link);
             window.URL.revokeObjectURL(blobUrl); // clean up
         } catch (error) {
             console.error("Download failed", error);
             alert("Download failed. Image may not allow download due to CORS.");
         }
     };
  */

    const handleDownload = async (url, filename) => {
        if (!isAuthenticated) {
            navigate('/login'); // redirect if not logged in
            return;
        }

        try {
            const response = await fetch(url, { mode: 'cors' });
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = filename || 'downloaded_image.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Download failed", error);
            alert("Download failed. Image may not allow download due to CORS.");
        }
    };




    return (
        <>
            <InternalBanner title={eventName} venue={eventVenue} />

            <section className="gallery">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 my-4">
                            <button className="btn-6 view-all-btnn mb-4" onClick={() => navigate(-1)}>
                                ⬅ Back
                            </button>


                            <div className="row row-cols-1 row-cols-md-3 row-cols-lg-4 row-cols-xl-4">
                                {images.length > 0 ? (
                                    images.map((img, index) => (
                                        <div key={index} className="thumb tab mb-4">
                                            <div onClick={() => handleClick(index)} style={{ cursor: 'pointer' }}>
                                                <LazyLoad className='download_img' height={200} offset={100} once>
                                                    <div className="thumbnail_img">
                                                        <img
                                                            className="w-100 thumbnail_main"
                                                            effect="blur"
                                                            src={img}
                                                            alt={` ${index + 1}`}
                                                        />

                                                        <div className='download_image_file'>
                                                            <FacebookShareButton url={img} className="social_icon" onClick={(e) => {e.stopPropagation();}}>
                                                                <FacebookIcon size={32} round />
                                                            </FacebookShareButton>
                                                            <WhatsappShareButton url={img} className="social_icon" onClick={(e) => {e.stopPropagation();}}>
                                                                <WhatsappIcon size={32} round />
                                                            </WhatsappShareButton>
                                                             <TwitterShareButton url={img} className="social_icon" onClick={(e) => {e.stopPropagation();}}>
                                                                <XIcon size={32} round />
                                                            </TwitterShareButton>
                                                            <img
                                                                src={`${process.env.PUBLIC_URL}/assets/images/elements/download_icon.png`}
                                                                className='download_gallery_image'
                                                                alt="Download"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation(); // prevent lightbox open
                                                                    handleDownload(img, `image_${index + 1}.jpg`);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                </LazyLoad>

                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>No images found for this event.</p>
                                )}
                            </div>

                            {isOpen && (
                                <Lightbox
                                    open={isOpen}
                                    close={() => setIsOpen(false)}
                                    slides={images.map(img => ({ src: img }))}
                                    index={currentIndex}
                                    onIndexChange={setCurrentIndex}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
